import { ErrorMessage } from '@hookform/error-message';
import ErrorMessageStyle from 'Components/Form/ErrorMessageStyle';
import Label from 'Components/Form/Label';
import { RegisterOptions } from 'react-hook-form';
export interface TextInputProps {
  labelIcon?: React.ReactNode;
  rules?: RegisterOptions;
  disable?: boolean;
  register?: any;
  label?: string;
  errors?: any;
  maxLength?: number;
  placeholder?: string;
  name: string;
}
export const CheckboxInputBasic = ({
  name,
  placeholder = 'Enter...',
  rules,
  label,
  labelIcon,
  disable,
  register,
  maxLength,
  errors,
}: TextInputProps) => {
  return (
    <>
      <div className="flex gap-2 items-center ">
        <input
          id={name}
          type="checkbox"
          className="cursor-pointer mr-2 form-checkbox w-5 h-5 border-0 text-green bg-gray-800 rounded focus:ring-0 focus:ring-offset-0"
          {...register(name, rules)}
        />

        {label && (
          <Label
            htmlFor={name}
            className="cursor-pointer"
            label={label}
            labelIcon={labelIcon}
          />
        )}
      </div>

      {errors && (
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => <ErrorMessageStyle message={message} />}
        />
      )}
    </>
  );
};
